import "./chunk-BBZEL7EG.js";
const SESSION_COOKIE_HEADER_NAME = "x-capsule-sid";
const VERSION_HEADER_NAME = "x-para-version";
const PARTNER_ID_HEADER_NAME = "x-partner-id";
const API_KEY_HEADER_NAME = "X-External-API-Key";
export {
  API_KEY_HEADER_NAME,
  PARTNER_ID_HEADER_NAME,
  SESSION_COOKIE_HEADER_NAME,
  VERSION_HEADER_NAME
};
